import { insertionCollision } from 'lib';

export const gridScheduleOrderCollision = (args) => (
  args.active.data?.current?.type === 'group'
    ? scheduleOrderGroupCollision(args)
    : insertionCollision(args)
);

function scheduleOrderGroupCollision({
  collisionRect,
  droppableRects,
  droppableContainers,
  active
}) {
  const collisions = [];

  const groupDroppableContainer = droppableContainers
    .filter(container => container.data?.current?.type === 'group');

  for (const droppableContainer of groupDroppableContainer) {
    const {id} = droppableContainer;
    const rect = droppableRects.get(id);

    if (rect) {
      const intersectionRatio = rect.top - collisionRect.top;
      collisions.push({
        id,
        data: { droppableContainer, intersectionRatio },
      })
    }
  }

  const groupsBeforeCollision = collisions.filter((collision) => collision.data?.intersectionRatio > 0)
  if (groupsBeforeCollision?.length) {
    return groupsBeforeCollision.sort((a, b) => a.data?.intersectionRatio - b.data?.intersectionRatio);
  }

  return collisions.sort((a, b) => b.data?.intersectionRatio - a.data?.intersectionRatio);
}
